<style>
  .modal-header{
    text-transform: capitalize;
  }
  .modal-body {
    padding: 0 1rem;
  }
</style>

<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  textarea{
    resize: none;
  }
</style>

<template>
  <form @submit="saveConfig">
    <b-modal :title="`Change ${name || 'Config'}`" :visible="configName !== null"
      @ok="close" @cancel="close" @hide="close">

      <Loader v-if="!configBeingEdited" :size="40" />

      <template v-else>
        <div class="form-group mt-3 mb-4">
          <label for="value" class="text-capitalize">{{name || 'Config'}}</label>

          <div class="mt-2" v-if="type === 'percent'">
            <vue-slider v-model="value" />
            <h1 class="mt-3">{{ value }}%</h1>
          </div>
          <input v-else id="value" class="form-control" v-model="value" type="text" required />
        </div>

        <template slot="modal-footer">
          <div class="row justify-content-end pb-0">
            <div class="px-3">
              <button :class="{disabled: savingConfig}" class="btn btn-primary px-4">
                {{ !savingConfig ? 'SUBMIT' : 'Please Wait...' }}
              </button>
            </div>
          </div>
        </template>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import { mapState } from 'vuex';
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'

  export default {
    name: 'EditGeneralConfig',
    props: {
      configName: {
        type: String,
        required: true
      }
    },
    mounted(){
      if(!this.configs && !this.fetchingConfigs){
        this.$store.dispatch('getConfigs');
        this.$store.subscribe(mutation => {
          if(mutation.type === 'SET_CONFIGS')
            this.$store.dispatch('setConfigBeingEdited', this.configName);
        });
      }
      else
        this.$store.dispatch('setConfigBeingEdited', this.configName);
    },
    beforeDestroy(){
      this.$store.dispatch('setConfigBeingEdited', null);
    },
    data(){
      return {
        name: '',
        type: '',
        value: ''
      }
    },
    computed: {
      ...mapState(['configs', 'fetchingConfigs', 'configBeingEdited', 'savingConfig'])
    },
    watch: {
      configBeingEdited: function(config){
        if(!config)
          return;

        this.name = config.displayName;
        this.value = config.value;
        if((config.type === "number" || config.type === "percent") && (!config.value || !config.value.length))
          this.value = 0;
          
        const couldBePercent = config.type === "number" && config.name.toLowerCase().indexOf('interest') !== -1;
        this.type = couldBePercent ? "percent" : config.type;
      }
    },
    methods: {
      close(){
        this.$router.replace('/configurations/general');
      },
      saveConfig(e){
        e.preventDefault();
        if(!this.configBeingEdited)
          return;

        const data = {
          ...this.configBeingEdited,
          value: this.value
        };

        this.$store.dispatch('updateConfig', data);
      }
    },
    components: {
      VueSlider
    }
  }
</script>
